// Filas y resumen de la página «Alertas» (puro, con test). Como la de Mapon
// (min 19-20 del video del 26-oct): unidad, fecha, tipo, la alerta, conductor,
// velocidad y dónde.
import { motionLabel, notificationTitle, typeLabel, typeMeta, type UnitNotification } from "./unitNotifications";

export interface AlertRow {
  id: string;
  fecha: string;
  unidad: string;
  tipo: string;
  alerta: string;
  conductor: string;
  velocidad: string;
  ubicacion: string;
  [key: string]: string;
}

const fmt = (ms: number | null) =>
  ms
    ? new Date(ms).toLocaleString("es-MX", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false })
    : "—";

export const alertRows = (items: UnitNotification[], unitName: (n: UnitNotification) => string): AlertRow[] =>
  items.map((n) => ({
    id: n.id,
    fecha: fmt(n.created_at),
    unidad: unitName(n),
    tipo: typeLabel(n.type),
    // Sin descripción ni título la celda (y el Excel) salía vacía, el mismo
    // renglón en blanco que #914 arregló en la campana: cae al nombre del tipo.
    alerta: n.description?.trim() || notificationTitle(n),
    conductor: n.driver_name || "—",
    velocidad: motionLabel(n) ?? "—",
    ubicacion: n.lat != null && n.lon != null ? `${n.lat.toFixed(5)}, ${n.lon.toFixed(5)}` : "—",
  }));

/** Totales para las tarjetas: todas, críticas (rojo), advertencias (ámbar) y el tipo más frecuente. */
export const alertSummary = (items: UnitNotification[]) => {
  const byType = new Map<string, number>();
  let critical = 0;
  let warning = 0;
  for (const n of items) {
    const tone = typeMeta(n.type).tone;
    if (tone === "red") critical++;
    if (tone === "amber") warning++;
    const k = typeLabel(n.type);
    byType.set(k, (byType.get(k) || 0) + 1);
  }
  const top = [...byType.entries()].sort((a, b) => b[1] - a[1])[0] ?? null;
  return { total: items.length, critical, warning, top };
};
